export default __webpack_public_path__ + "static/media/student_note_icon.96768ae1.svg";